module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.674f50d.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/fontawesome-webfont.eot?v=4.7.0
// module id = 368
// module chunks = 4